function MeanBits(meanBits) {
    this.bits = meanBits;
}

module.exports = MeanBits;



//////////////////
// WEBPACK FOOTER
// ./~/lamejs/src/js/MeanBits.js
// module id = 63
// module chunks = 0